import { Container } from "@mui/material";

const Footer = () => {
    return (
        <footer>
            <Container>
                <p>
                    &copy; CareSync 2024
                </p>
            </Container>
        </footer>
    )
}

export default Footer